import { styled } from '@spazious/dollhouse-theme';

import { Paper, PaperProps } from '../Paper/index.js';

export interface DialogPaperProps extends Omit<PaperProps, 'maxWidth'> {
  children?: React.ReactNode;
  scroll: 'body' | 'paper';
  fullWidth?: boolean;
  fullScreen?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | string | false;
}

export const DialogPaper = styled(Paper).withConfig({
  shouldForwardProp: (prop) => !['scroll', 'fullWidth', 'maxWidth', 'fullScreen'].includes(prop),
  displayName: 'DialogPaper',
})<DialogPaperProps>`
  margin: 32px;
  position: relative;
  overflow-y: auto;
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.28);
  @media print {
    overflow-y: visible;
    box-shadow: none;
  }
  ${({ scroll }) =>
    ({
      paper: `
      display: flex;
      flex-direction: column;
      max-height: calc(100% - 64px);
    `,

      body: `
      display: inline-block;
      vertical-align: middle;
      text-align: left;
    `,
    }[scroll])}
  ${({ fullWidth }) => fullWidth && `width: calc(100% - 64px);`}
  ${({ fullScreen }) =>
    fullScreen &&
    `
    margin: 0;
    width: 100%;
    max-width: 100%;
    height: 100%;
    max-height: none;
    border-radius: 0;
    &:after {
      content: "";
      display: inline-block;
      vertical-align: middle;
      height: 100%;
      width: 0;
    }
  `}
  ${({ maxWidth }) =>
    ({
      xs: `
      max-width: 444px;
      @media (max-width: 444px) {
        max-width: calc(100% - 64px);
      }
    `,
      sm: `
      max-width: 600px;
      @media (max-width: 600px) {
        max-width: calc(100% - 64px);
      }
    `,
      md: `
      max-width: 960px;
      @media (max-width: 960px) {
        max-width: calc(100% - 64px);
      }
    `,
      lg: `
      max-width: 1280px;
      @media (max-width: 1280px) {
        max-width: calc(100% - 64px);
      }
    `,
      xl: `
      max-width: 1920px;
      @media (max-width: 1920px) {
        max-width: calc(100% - 64px);
      }
    `,
    }[maxWidth as string] ?? (maxWidth ? `max-width: ${maxWidth};` : ''))}
`;
